/**
 * Build up a placeholder date format string based on the given date components.
 *
 * @param datePattern an array of characters, where each character represents a component in a
 * date format string; for example:
 *
 *  `["m","d","Y"]
 *
 * @returns a date format string; for example, given the previous example input, the returned
 * date format string would be:
 *
 *  "MM/DD/YYYY"
 */
export const determinePotentialPlaceholder = (datePattern: Array<string>): string => {
  let fmtMonth = "";
  let fmtDay = "";
  let fmtYear = "";

  datePattern.forEach((dateComponent) => {
    switch (dateComponent) {
      case "m": {
        fmtMonth = "MM";
        return;
      }
      case "d": {
        fmtDay = "DD";
        return;
      }
      case "Y": {
        fmtYear = "YYYY";
        return;
      }
      default: {
        return;
      }
    }
  });

  return `${fmtMonth}${fmtMonth.length && "/"}${fmtDay}${fmtDay.length && "/"}${fmtYear}`;
};
